import React, { useContext, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import joinicons from "../../../assets/img/join-icon.svg"
import "../../../assets/css/joincommunityyy.css";
import "../../../assets/css/style.css";
import Spinner from "../../../commonComponents/Spinner";
import { Stepper, Step } from 'react-form-stepper';
import { ApiHelper } from "../../../helpers/ApiHelper";
import { API } from "../../../services/api";
import Validation from "../../../commonComponents/Validation";
import { CommunityContext } from "../../../config/CommunityContext";
import { joinCommunity } from "../../../services/apiCommunity";
import { useNavigate } from "react-router-dom";
import CreatePost from "../../Posts/CreatePost";

const JoinACommunity = ({ isJoinCommunity, handleClose, community, getCommunity, openCreatePost }) => {
  const user = JSON.parse(localStorage.getItem('userData'));
  const communityData = JSON.parse(localStorage.getItem('communityData'));
  const navigate = useNavigate();
  const Group = require("../../../assets/img/Featured icon.jpg");
  const { fetchAllCommunities } = useContext(CommunityContext);
  const [step, setStep] = useState(0);
  const [communityMemberTypes, setCommunityMemberTypes] = useState([]);
  const [error, setError] = useState('');
  const [isPrivacy, setIsPrivacy] = useState(false);
  const [joinCommunityArr, setJoinCommunityArr] = useState([]);
  const [selectedMemberType, setSelectedMemberType] = useState('Select Member type');


  useEffect(() => {
    if (isJoinCommunity && user.userType !== 'organization') {
      getAllCommunityMemberTypes();
    }
    if (user.userType === 'organization') {
      setStep(1);
      setSelectedMemberType("");
    }


  }, [isJoinCommunity])
  const getAllCommunityMemberTypes = async () => {
    const formData = {
      filter: "all"
    }
    await ApiHelper.post(API.getAllCommunityMemberTypes, formData)
      .then((resData) => {
        setCommunityMemberTypes(resData.data.data)
      })
      .catch((err) => {
        console.log(err, 'err');
      });
  }
  const next = (step) => {
    if (step === 0) {
      if (selectedMemberType === "Select Member type" && user.userType !== 'organization') {
        setError(true)
      }
      else {
        if (step < 2) setStep(step + 1);
      }
    }
    else if (step === 1) {
      if (isPrivacy) {
        handleJoinCommunity();
        if (step < 2) setStep(step + 1);
      }
      else {
        setError(true)
      }
    }
  };
  const back = (step) => {

    if (step > 0) setStep(step - 1);
    if (step === 0) handleClose();

  };
  const handleJoinCommunity = async () => {
    localStorage.setItem("communityId", community.communities._id);
    localStorage.setItem(
      "communityName",
      community?.communities?.communityName
    );
    localStorage.setItem("communityData", JSON.stringify(community?.communities));

    const formData = {
      userid: user._id,
      communityid: community.communities._id,
      membertype: selectedMemberType
    }
    let communityJoin = await joinCommunity(formData);
    setJoinCommunityArr(communityJoin.data)
    if (communityJoin.status) {
      await fetchAllCommunities({ userid: user._id });
    }

    getCommunity()
  }
  return (

    <div >
      <Modal show={isJoinCommunity} onHide={handleClose}
        dialogClassName="custom-modal modal-dialog-centered">
        <Modal.Header closeButton>
          <div className="popupheader">
            <div className="mod-bor-icon" >
              <img src={joinicons} className="mod-icon"></img>
            </div>
            <div className="header">
              <h4 className="modal-tittle">{`Join the ${community?.communities?.communityName}`}</h4>
              {/* <p className="Stronger"></p> */}

            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div >
            <Stepper activeStep={step}
              size={2}
              styleConfig={{
                stepperContainerStyle: {
                  padding: '24px 32px',
                  wight: '23px',
                  height: '23px'
                },
                connectorStyle: {
                  height: '2px' // this is the connector line thickness
                },
                stepButton: {
                  height: '20px', // Adjust StepButton height
                  width: '20px',  // Adjust StepButton width
                  fontSize: '14px', // Font size for content inside StepButton
                },
                activeBgColor: '#2E7B88',
                activeTextColor: '#fff',
                completedBgColor: '#2E7B88',
                connectorStateColors: true,
                activeColor: '#2E7B88',
                completedColor: '#2E7B88',
                completedTextColor: '#fff',
                padding: '12px 16px',  // May apply to StepButton too, depending on implementation
                fontWeight: '400',
              }}>
              {user && user.userType !== 'organization' ? (
                <Step label={<span style={{
                }}>About Me</span>} />
              ) : (null)}

              <Step label={<span style={{
              }}>Guidelines</span>} />

              <Step label={<span style={{
              }}>Confirmation</span>} />
            </Stepper>

            {step === 0 && (
              <div className="first-section">
                <div className="mb-1 row">
                  <label for="inputPassword" className="col-sm-4 col-form-label font ">I'm joining this community because...</label>
                  <div className="col-sm-8">
                    <select className="form-select font" aria-label="Default select example" value={selectedMemberType}
                      onChange={e => setSelectedMemberType(e.target.value)}>
                      <option value="Select Member type" className="font">Select Member type</option>
                      {Array.isArray(communityMemberTypes) &&
                        communityMemberTypes.map((item) => (
                          <option key={item._id} value={item._id} className="font">
                            {item.memberTypeName}
                          </option>
                        ))}
                    </select>
                    {selectedMemberType === "Select Member type" && error ? (
                      <Validation message={'Please select member type'} />
                    ) : null}
                  </div>
                </div>
              </div>
            )}
            {step === 1 && (
              <div className="second-section">
                <div className="mb-1 row">
                  <div class="guidelines-box mb-4">
                    <div dangerouslySetInnerHTML={{ __html: `<p>When you join a Dreamers Health Community, you agree to engage respectfully, share responsibly, and protect others’ privacy. </p> <p>Communities are safe spaces created for learning, support, and empowerment—not for judgment, solicitation, or self-promotion. Please post only truthful, non-offensive content and avoid sharing anyone’s private or health information without consent.</p>
                      <p>Remember that all discussions are for informational purposes only and never a substitute for professional medical advice. Advertising, research, and organizational messages shown on the platform follow strict transparency and privacy standards.</p><p></p>By joining, you help us build a supportive environment where compassion, accuracy, and trust guide every interaction.` }} />
                  </div>

                  <div className="mb-2">
                    <p className="sty-logg-join-comm">
                      <input type="checkbox" name="payment" id="vessels"
                        className="radio-des vesselradio form-check-input radiobtn"
                        onChange={(e) => { setIsPrivacy(e.target.checked) }} checked={isPrivacy ? 'checked' : ''}
                      />
                      I have read and agree to the community's guidelines {isPrivacy === false && error ? <span className="text-dange" style={{ color: "red" }}> * </span> : null} </p>
                  </div>

                </div>
              </div>)}
            {step === 2 && (
              <div class="welcome-section">
                <h2 className="" >Welcome to the</h2>
                <h2 className="mb-3" >{`${community?.communities?.communityName} Community!`}</h2> 
                <p className="text-start" >
                  {`Hey, ${user?.firstName}! `}<br></br> {`Welcome to
Dreamers Health ${community?.communities?.communityName} Community! Our mission is to help you find
people navigating the same challenges you are and to provide a safe
space where you can ask questions and share experiences.
`}
                </p>
              </div>)}




          </div>


        </Modal.Body>

        <Modal.Footer className="full-w">
          {step === 2 ? (
            <>
              <button type="button" className="cancel-btn" onClick={() => {
                handleClose(); // closes JoinACommunity modal
                setTimeout(() => {
                  openCreatePost();
                }, 300);  // opens CreatePost popup
              }}>
                Create my first post
              </button>
              <button type="button" className="next-btn" onClick={() => navigate(`/feed/${communityData?.communityName.trim().replace(/\s+/g, '-').toLowerCase()}`)}>
                Go to Community
              </button>
            </>
          ) : (
            <>
              {user.userType !== 'organization' ? (
                <button type="button" className="cancel-btn" onClick={() => back(step)} >
                  Cancel
                </button>
              ) : (<button type="button" className="cancel-btn" onClick={handleClose}>
                Cancel
              </button>)}

              <button type="button" className="next-btn" onClick={() => next(step)}>
                Next
              </button>
            </>
          )}
        </Modal.Footer>


      </Modal>

    </div>
  );

};
export default JoinACommunity;
